import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const MapSection = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <motion.div
        whileHover={{ scale: 1.01 }}
        className="h-96 w-full relative"
      >
        <iframe
  title={t('contact.mapTitle')}
  width="100%"
  height="100%"
  frameBorder="0"
  scrolling="no"
  marginHeight="0"
  marginWidth="0"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d723.9341710026592!2d10.539485207072422!3d52.2762189514746!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47aff42ce89f6141%3A0xfdd2ecbeec4e50c!2sE-Tower%20TU%20BS%20Fakult%C3%A4t%205!5e1!3m2!1sen!2sde!4v1775054028299!5m2!1sen!2sde"
  className="absolute inset-0"
  style={{ border: 0 }}
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>
      </motion.div>
      <div className="p-4 bg-gray-50">
        <p className="text-sm text-gray-600 text-center">
          {t('contact.mapCaption')}
        </p>
      </div>
    </div>
  );
};

export default MapSection;